module.exports = __webpack_public_path__ + "assets/img/2.d3ef0205.jpg";